import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=616a9ef3&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"
import style0 from "./Profile.vue?vue&type=style&index=0&id=616a9ef3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616a9ef3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('616a9ef3')) {
      api.createRecord('616a9ef3', component.options)
    } else {
      api.reload('616a9ef3', component.options)
    }
    module.hot.accept("./Profile.vue?vue&type=template&id=616a9ef3&scoped=true", function () {
      api.rerender('616a9ef3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mauser/Profile.vue"
export default component.exports